import styled from "@emotion/styled";

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SliderWrapper = styled.div`
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ValueInputIcon = styled.span`
  position: absolute;
  right: 15px;
  top: 11px;
  width: 20px;
  text-align: center;
  color: grey;
  i {
    font-size: 12px;
  }
`;

export const ResetButton = styled.button`
  width: 30px;
  padding: 0px;
  border: none;
  background: none;
  color: grey;
  i {
    font-size: 18px;
  }
`;
